import api from "./api";
import { APIS } from "../endpoints";

export const getAllStaticWordsData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.multiLingual}`, {
        params: params
    })

   return result ? result?.data : [];
};

export const getStaticWordData = async (keyOrId) => {
    // Backend expects _id in the path
    const endpoint = `${APIS.BASE_URL}${APIS.multiLingual}/${keyOrId}`;

    try {
        const result = await api.get(endpoint);

        // The API has triple-nested data: result.data.data.data is the array
        return result?.data?.data?.data || [];
    } catch (error) {
        console.error('Error fetching static word data:', error);
        return [];
    }
};

// New function to get record by key
export const getStaticWordByKey = async (key) => {
    try {
        // Fetch all records and filter by key
        const result = await getAllStaticWordsData(1000, 1, key); // Large limit to get all
        
        if (result?.data?.data) {
            // Find the record with matching key
            const record = result.data.data.find(item => item.key === key);
            return record || null;
        }
        return null;
    } catch (error) {
        console.error('Error fetching static word by key:', error);
        return null;
    }
};

export const updateStaticWordData = async (idOrKey, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    // Backend expects _id in the path
    const result = await api.put(`${APIS.BASE_URL}${APIS.multiLingual}/${idOrKey}`, payload)

    return result ? result?.data : [];
};

export const createNewStaticWord = async (data) => {

    const result = await api.post(`${APIS.BASE_URL}${APIS.multiLingual}`, data)

    return result ? result?.data : [];
}
